import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import {css} from "@emotion/core";
import * as moment from "moment";
import {connect}  from  "react-redux";
import loadingGif from "../../assets/img/loading.gif";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient, user_activities } from '../../helpers/utils.js';
import MultiCsvReportDownload from '../DownloadReport/MultiCsvReportDownload.jsx';
import UtidFilter from '../../filters/UtidFilter.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import GenieEventFilter from '../../filters/GenieEventFilter.jsx';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config('0', '0', '2020-02-01','0');
var GRDDumpTable='';

class GRDDumpReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            ciutidIds: '',
            loading:false,
            isChange: false,
            object_code:[],
            state_code:"",
            tableHeaders:[],
            tableBody:[],
            event_names:"",
            download_limit:31
        }

    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");


        isReportAccess(AllAccessPermissions, 'GRD_dump_report');
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });


    }
    componentDidUpdate() {

    }
    componentDidMount() {
        this.get_download_limit();
        this.get_columns('');
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'live_transaction_dump_report','sparcs')

    }
    get_download_limit(){
        axios.get(config.get('API_URL')+'/filters/get-grd-download-limit/',
       {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {

            }
        }).then(response => {
            console.log(response.data);
            this.setState({
                download_limit:response.data
            })


        }).catch(error => {
          console.log(error);
        });
    }
    get_columns(e) {
        this.setState({
            loading:true,
            is_record: true,
            is_exp_button: false
        })
        let tableHeaders=[];
        let tableBody = [];
        let headerList =[];
        axios.post(config.get('API_URL') + '/InternalReport/grd-dump-reports-row', {
            event_names: this.state.event_names,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,

            user_id: this.state.user_id,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
//             console.log("jhjhsgdhsgdh");
//             console.log(response.data);
            if(Array.isArray(response.data.data) && response.data.data.length){
                //if (response.data.data != null) {
                const keys = Object.keys(response.data.data[0]);
                //console.log(keys);
                let keyVal='';

                keys.forEach(function (k) {
                    if (k !== 'id') {
                        tableHeaders.push({
                            sTitle: k,
                            mData: k.replace(/\./g, '\\.')
                            //optionally do some type detection here for render function
                        });
                        tableBody.push({
                            data: k,
                        });
                        headerList.push(k);
                    }
                });
//                 console.log(tableHeaders);
//                 console.log(tableBody);
                this.setState({
                    loading: false,
                    is_record: true,
                    is_exp_button: true,
                    tableHeaders:tableHeaders,
                    tableBody:tableBody,
                    headerList:headerList
                });
                this._get_filtered_grd_dump_report(tableHeaders, tableBody,headerList);
            }else {
                if ($.fn.DataTable.isDataTable('#GRDDumpTable')) {
                    $('#GRDDumpTable').DataTable().clear().destroy();
                }
                this.setState({
                    is_record: false,
                    loading: false,
                    isChange: false,
                    is_exp_button: false
                });
            }
        });
    }

    downLoadGRDDumpCheck (e){
        let transaction_type = this.state.txnTypeIDs;
        if (Array.isArray(this.state.txnTypeIDs) && this.state.txnTypeIDs.includes("all") === true) {
            transaction_type = ""
        }

        let filters = {
            event_name: this.state.event_names,
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            user_id: this.state.user_id,
            report_code:'GRD_dump_report',
            download: 1,
        }
        this.setState({
            filters:filters
        })

        this.refs.downloadAllReport.downLoadReport(filters, '/internal_reports/grd_dump_report','GRD_dump_report',this.state.download_limit);

    }

    _get_filtered_grd_dump_report(tableHeaders, tableBody,headerList) {
//         console.log(tableHeaders);
//         console.log(tableBody);
        var that = this;
        var a = moment(this.state.todSend);
        var b = moment(this.state.yestSend);


        var postData = {
            event_names: this.state.event_names,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            report_code:'GRD_dump_report',
            user_id: this.state.user_id,
        };
        if ($.fn.DataTable.isDataTable('#GRDDumpTable')) {
            $('#GRDDumpTable').DataTable().clear().destroy();
        }

        GRDDumpTable = $('#GRDDumpTable').DataTable(
            {
                order:[],
                //"dom": 'fltip',
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                //"autoWidth": true,
                "responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/InternalReport/grd-dump-reports",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        isApiResponse(true);
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                        console.log("error", data);
                    },
                    complete: function (data) {
                        isApiResponse(true)
                        console.log("complete", data);
                    },
                },

                aoColumns:tableHeaders,
                columns: tableBody,
            });


    }

    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
//         if(this.state.object_type==='Innoviti')
//         {
//
//             this.refs.reloadUtid.ci_utid('','','',false,'');
//         }
        this.refs.genieEventFilter.restgenieEventFilter();
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            event_names:'',
            ciutidIds: '',
            isChange: false

        })

        setTimeout(function(){
            this.componentWillMount()
            this.componentDidMount()
        }.bind(this), 200);
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
    }
    handleGenieEvents = (optionSelected, event_names) =>
    {
        this.setState({
            event_names:event_names,
            isChange: true
        });
    }

    render() {
        return(
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">GRD Dump Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                                <div><label>Event Date Filter: </label></div>
                                                <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                                start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                            </div>
                                            <div className="col-md-4 filter-bottom5 padd-5">
                                                <label> Event Name </label>
                                                <GenieEventFilter ref="genieEventFilter" onSelectgenieEvent = {this.handleGenieEvents} />
                                                <div className="clearfix"></div>
                                            </div>
                                            
                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this._get_filtered_grd_dump_report.bind(this,this.state.tableHeaders,this.state.tableBody)}>Apply</button>
                                            <button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>


                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    {this.state.is_exp_button ?
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.downLoadGRDDumpCheck.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>:null }
                                    <div className="clearfix"></div>
                                    {this.state.is_record ?
                                    <div className="content-tdetails-table table-full-width marginTop0">
                                        <table id="GRDDumpTable" className="table table-striped table-hover">

                                        </table>
                                    </div>:<div className="empty_data" style={{marginTop:'20px'}}> No record Found</div>
                                    }
                                    <MultiCsvReportDownload ref="downloadAllReport" />

                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
        currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
}
export default connect(null,mapDispatchToProps)(GRDDumpReport)